/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { useState } from "react";

import { Block } from "src/classes/block";
import { BasePlate } from "src/classes/plate/BasePlate/BasePlate";
import { Rectangle } from "src/classes/plate/lib/types";
import { Plate } from "src/classes/plate/Plate";
import { BlockContextMenu as BlockContextMenu } from "src/components/Block/ContextMenu";
import { PlateContextMenu } from "src/components/Plate/ContextMenu";

interface Props {
  children: React.ReactNode | React.ReactNode[];
  editable: boolean;
  plate: Plate | BasePlate | null;
  block: Block | null;
}

export function ContextMenu({ children, plate, block, editable }: Props) {
  // controls whether and where the menu is shown
  const [position, setPosition] = useState<Rectangle | null>();

  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setPosition({ top: e.pageY, right: e.pageX, bottom: e.pageY, left: e.pageX });
  };

  const closeContextMenu = () => {
    setPosition(null);
  };

  return (
    <>
      <div onContextMenu={handleContextMenu}>{children}</div>
      {position && (
        <>
          {plate && <PlateContextMenu plate={plate} anchor={position} close={closeContextMenu} />}
          {block && (
            <BlockContextMenu block={block} editable={editable} anchor={position} close={closeContextMenu} />
          )}
        </>
      )}
    </>
  );
}
